"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Navbar = void 0;
var _react = _interopRequireWildcard(require("react"));
var _bodyScrollLock = require("body-scroll-lock");
var _NavItem = require("./NavItem");
var _SmartSections = require("../SmartSections");
var _getWindowScroll2 = _interopRequireDefault(require("../../utils/getWindowScroll"));
var _animateScroll = _interopRequireDefault(require("../../utils/animateScroll"));
var _reactCollapse = require("react-collapse");
var _CssClassNames2 = _interopRequireDefault(require("../../scss/CssClassNames"));
var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _CssClassNames = new _CssClassNames2["default"](_stylesModule["default"], ['utility', 'transition']),
  className = _CssClassNames.className;
var Navbar = /*#__PURE__*/function (_PureComponent) {
  _inherits(Navbar, _PureComponent);
  var _super = _createSuper(Navbar);
  function Navbar(props) {
    var _this;
    _classCallCheck(this, Navbar);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "state", {
      isScrolled: false,
      navbarShown: false,
      navbarAnimating: false,
      hideNavbar: false,
      activeDropdown: null,
      showOverlay: false,
      showOverlayComplete: false,
      forceCloseDropdown: false
    });
    _defineProperty(_assertThisInitialized(_this), "handleWindowScroll", function () {
      var _this$props$scrollToH = _this.props.scrollToHide,
        scrollToHide = _this$props$scrollToH === void 0 ? 20 : _this$props$scrollToH;
      var _getWindowScroll = (0, _getWindowScroll2["default"])(),
        y = _getWindowScroll.y;
      if (!_this.state.isScrolled && y >= scrollToHide) {
        _this.setState({
          isScrolled: true
        });
      } else if (_this.state.isScrolled && y < scrollToHide) {
        _this.setState({
          isScrolled: false
        });
      }
      if (y > _this.lastY && _this.state.isScrolled) {
        if (!_this.state.hideNavbar) {
          _this.setState({
            hideNavbar: true
          });
        }
      } else {
        if (_this.state.hideNavbar && _this.navbar.current.dataset.hide !== 'true') {
          _this.setState({
            hideNavbar: false
          });
        }
        if (_this.navbar.current.dataset.hide === 'true') {
          _this.setState({
            hideNavbar: true
          });
        }
      }
      _this.lastY = y;
    });
    _defineProperty(_assertThisInitialized(_this), "toggleCollapse", function (isToggle) {
      return function () {
        _this.setState(function (state) {
          return _objectSpread(_objectSpread(_objectSpread({}, state.navbarShown && {
            navbarShown: false
          }), isToggle && {
            navbarShown: !state.navbarShown
          }), {}, {
            navbarAnimating: true
          });
        });
      };
    });
    _this.navbar = /*#__PURE__*/(0, _react.createRef)();
    _this.handleClickBrand = _this.handleClickBrand.bind(_assertThisInitialized(_this));
    _this.handleWindowScroll = _this.handleWindowScroll.bind(_assertThisInitialized(_this));
    _this.toggleCollapse = _this.toggleCollapse.bind(_assertThisInitialized(_this));
    _this.handleExpanded = _this.handleExpanded.bind(_assertThisInitialized(_this));
    _this.handleDropdownOpen = _this.handleDropdownOpen.bind(_assertThisInitialized(_this));
    _this.handleDropdownClose = _this.handleDropdownClose.bind(_assertThisInitialized(_this));
    _this.closeDropdown = _this.closeDropdown.bind(_assertThisInitialized(_this));
    _this.lastY = null;
    return _this;
  }
  _createClass(Navbar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isFixed) {
        this.handleWindowScroll();
      }
      if (typeof window !== 'undefined' && this.props.isFixed) {
        window.addEventListener('scroll', this.handleWindowScroll);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (typeof window !== 'undefined' && this.props.isFixed) {
        window.removeEventListener('scroll', this.handleWindowScroll);
      }
      (0, _bodyScrollLock.clearAllBodyScrollLocks)();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;
      if (prevState.navbarShown !== this.state.navbarShown && this.navbar.current) {
        var element = this.navbar.current.querySelector('.scrollable-content');
        if (!element) {
          element = this.navbar.current;
        }
        if (this.state.navbarShown) {
          (0, _bodyScrollLock.disableBodyScroll)(element);
        } else {
          (0, _bodyScrollLock.enableBodyScroll)(element);
        }
      }
      if (!prevState.showOverlay && this.state.showOverlay) {
        this.setState({
          showOverlayComplete: true
        });
      } else if (prevState.showOverlayComplete && !this.state.showOverlayComplete) {
        setTimeout(function () {
          _this2.setState({
            showOverlay: false
          });
        }, 200);
      }
      if (typeof window !== 'undefined' && (prevState.navbarShown !== this.state.navbarShown || prevState.navbarAnimating !== this.state.navbarAnimating)) {
        window.document.body.dataset.navbarShown = this.state.navbarShown && !this.state.navbarAnimating ? 'true' : 'false';
      }
      if (this.props.onToggleScroll && prevState.isScrolled !== this.state.isScrolled) {
        this.props.onToggleScroll(this.state.isScrolled);
      }
    }
  }, {
    key: "handleExpanded",
    value: function handleExpanded(e) {
      this.setState({
        navbarAnimating: false
      });
    }
  }, {
    key: "handleClickBrand",
    value: function handleClickBrand(e) {
      var _this$props = this.props,
        _this$props$href = _this$props.href,
        href = _this$props$href === void 0 ? '/' : _this$props$href,
        _this$props$onClickBr = _this$props.onClickBrand,
        onClickBrand = _this$props$onClickBr === void 0 ? null : _this$props$onClickBr;
      if (onClickBrand) {
        onClickBrand();
      }
      if (href === window.location.pathname) {
        e.preventDefault();
        (0, _animateScroll["default"])(0);
      }
    }
  }, {
    key: "handleDropdownOpen",
    value: function handleDropdownOpen(name) {
      if (this.props.onDropdownOpen) {
        this.props.onDropdownOpen();
      }
      this.setState({
        activeDropdown: name,
        showOverlay: true
      });
    }
  }, {
    key: "closeDropdown",
    value: function closeDropdown() {
      this.setState({
        forceCloseDropdown: true
      });
    }
  }, {
    key: "handleDropdownClose",
    value: function handleDropdownClose(name) {
      var _this3 = this;
      setTimeout(function () {
        if (name === _this3.state.activeDropdown) {
          if (_this3.props.onDropdownClose) {
            _this3.props.onDropdownClose();
          }
          _this3.setState({
            showOverlayComplete: false,
            forceCloseDropdown: false
          });
        }
      }, 100);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props2 = this.props,
        _this$props2$extraCla = _this$props2.extraClass,
        extraClass = _this$props2$extraCla === void 0 ? '' : _this$props2$extraCla,
        _this$props2$isTransp = _this$props2.isTransparent,
        isTransparent = _this$props2$isTransp === void 0 ? false : _this$props2$isTransp,
        _this$props2$hideOnSc = _this$props2.hideOnScroll,
        hideOnScroll = _this$props2$hideOnSc === void 0 ? false : _this$props2$hideOnSc,
        _this$props2$showBran = _this$props2.showBrand,
        showBrand = _this$props2$showBran === void 0 ? true : _this$props2$showBran,
        _this$props2$isFixed = _this$props2.isFixed,
        isFixed = _this$props2$isFixed === void 0 ? true : _this$props2$isFixed,
        _this$props2$wrapperC = _this$props2.wrapperClassName,
        wrapperClassName = _this$props2$wrapperC === void 0 ? function () {} : _this$props2$wrapperC,
        _this$props2$logo = _this$props2.logo,
        logo = _this$props2$logo === void 0 ? null : _this$props2$logo,
        _this$props2$logoDom = _this$props2.logoDom,
        logoDom = _this$props2$logoDom === void 0 ? null : _this$props2$logoDom,
        _this$props2$logoNavb = _this$props2.logoNavbarShown,
        logoNavbarShown = _this$props2$logoNavb === void 0 ? null : _this$props2$logoNavb,
        _this$props2$brandPar = _this$props2.brandParams,
        brandParams = _this$props2$brandPar === void 0 ? {} : _this$props2$brandPar,
        _this$props2$logoAlt = _this$props2.logoAlt,
        logoAlt = _this$props2$logoAlt === void 0 ? '' : _this$props2$logoAlt,
        _this$props2$dark = _this$props2.dark,
        dark = _this$props2$dark === void 0 ? false : _this$props2$dark,
        _this$props2$scrollDa = _this$props2.scrollDark,
        scrollDark = _this$props2$scrollDa === void 0 ? false : _this$props2$scrollDa,
        _this$props2$navs = _this$props2.navs,
        navs = _this$props2$navs === void 0 ? [] : _this$props2$navs,
        _this$props2$scheme = _this$props2.scheme,
        scheme = _this$props2$scheme === void 0 ? null : _this$props2$scheme,
        _this$props2$Tag = _this$props2.Tag,
        Tag = _this$props2$Tag === void 0 ? null : _this$props2$Tag,
        _this$props2$href = _this$props2.href,
        href = _this$props2$href === void 0 ? '/' : _this$props2$href,
        _this$props2$navbarEx = _this$props2.navbarExtraContent,
        navbarExtraContent = _this$props2$navbarEx === void 0 ? null : _this$props2$navbarEx,
        _this$props2$customTo = _this$props2.customTogglerIcon,
        customTogglerIcon = _this$props2$customTo === void 0 ? null : _this$props2$customTo,
        _this$props2$customTo2 = _this$props2.customTogglerIconOpen,
        customTogglerIconOpen = _this$props2$customTo2 === void 0 ? null : _this$props2$customTo2,
        _this$props2$customTo3 = _this$props2.customToggler,
        customToggler = _this$props2$customTo3 === void 0 ? null : _this$props2$customTo3,
        _this$props2$dropdown = _this$props2.dropdownClassName,
        dropdownClassName = _this$props2$dropdown === void 0 ? null : _this$props2$dropdown,
        _this$props2$dropdown2 = _this$props2.dropdownCollapseClassName,
        dropdownCollapseClassName = _this$props2$dropdown2 === void 0 ? null : _this$props2$dropdown2,
        dropdownOverlay = _this$props2.dropdownOverlay,
        dropdownOverlayMobile = _this$props2.dropdownOverlayMobile,
        dropdownOverlayClassName = _this$props2.dropdownOverlayClassName,
        NavbarBrandTag = _this$props2.NavbarBrandTag,
        blockScrollStyle = _this$props2.blockScrollStyle;
      var FinalNavbarBrandTag = NavbarBrandTag ? NavbarBrandTag : scheme === 'gatsby' || Tag ? Tag : 'a';
      var navbarBrandParams = scheme === 'gatsby' ? _objectSpread(_objectSpread({}, brandParams), {}, {
        to: href
      }) : _objectSpread(_objectSpread({}, brandParams), {}, {
        href: href
      });
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("nav", _extends({
        ref: this.navbar,
        id: "navbar"
      }, className("\n                    navbar navbar-expand-lg \n                    ".concat(isFixed && showBrand || this.state.navbarShown ? 'position-fixed fixed-top' : '', "\n                    ").concat(dark && (!this.state.isScrolled || this.state.isScrolled && scrollDark) ? 'navbar-dark' : 'navbar-light', " \n                    ").concat(isTransparent ? 'navbar-transparent' : '', "\n                    ").concat(extraClass, "\n                    ").concat(this.state.hideNavbar && hideOnScroll ? 'navbar-hide' : '', "\n                    ").concat(this.state.navbarShown ? 'navbar-shown' : '', "\n                    ").concat(!blockScrollStyle && this.state.isScrolled ? 'navbar-scroll' : '', "\n                    ").concat(this.state.navbarAnimating ? 'navbar-animating' : '', "\n                "), wrapperClassName(this.state.isScrolled, this.state.navbarShown, this.state.navbarAnimating))), /*#__PURE__*/_react["default"].createElement(FinalNavbarBrandTag, _extends({
        id: "navbar-brand"
      }, className("navbar-brand ".concat(showBrand || this.state.navbarShown ? '' : 'hide')), navbarBrandParams, {
        onClick: this.handleClickBrand
      }), /*#__PURE__*/_react["default"].createElement("div", null, logoDom ? logoDom : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, logo ? /*#__PURE__*/_react["default"].createElement("img", _extends({
        src: logo
      }, className(logoNavbarShown ? 'navbar-brand-default' : ''), {
        alt: logoAlt
      })) : "LOGO", logoNavbarShown ? /*#__PURE__*/_react["default"].createElement("img", _extends({}, className('navbar-brand-shown'), {
        src: logoNavbarShown,
        alt: ""
      })) : null))), /*#__PURE__*/_react["default"].createElement("button", _extends({}, className("navbar-toggler ".concat(customToggler ? customToggler : '')), {
        type: "button",
        onClick: this.toggleCollapse(true),
        "aria-pressed": this.state.navbarShown,
        "aria-expanded": this.state.navbarShown,
        "aria-label": this.state.navbarShown ? 'Cerrar menú' : 'Abrir menú'
      }), /*#__PURE__*/_react["default"].createElement("span", className("navbar-toggler-icon ".concat(customTogglerIcon ? customTogglerIcon : '', " ").concat(this.state.navbarShown && customTogglerIconOpen ? customTogglerIconOpen : '')))), /*#__PURE__*/_react["default"].createElement("div", className('navbar-collapse-space')), navs || navbarExtraContent ? /*#__PURE__*/_react["default"].createElement(_reactCollapse.Collapse, {
        isOpened: this.state.navbarShown,
        onRest: this.handleExpanded,
        theme: {
          collapse: className('navbar-collapse').className,
          content: "".concat(className('navbar-show-height').className, " scrollable-content")
        }
      }, navs ? navs.filter(function (n) {
        return !!n;
      }).map(function (nav, i) {
        return /*#__PURE__*/_react["default"].createElement("ul", _extends({
          key: i
        }, className("navbar-nav ".concat(nav.align === 'center' ? 'navbar-center' : nav.align === 'left' ? 'navbar-left' : 'navbar-right', " ").concat(i === 0 ? 'first' : '', " ").concat(nav.className ? nav.className : '', " modal-open-fix"))), nav.items.map(function (item, k) {
          if (item.section) {
            return /*#__PURE__*/_react["default"].createElement(_SmartSections.SectionSpy, {
              key: k,
              name: item.section,
              title: item.title,
              render: function render(section) {
                return /*#__PURE__*/_react["default"].createElement(_NavItem.NavItem, _extends({}, item, section, {
                  isTransparent: isTransparent,
                  href: "".concat(item.href, "#").concat(item.section),
                  onClickAlways: _this4.toggleCollapse,
                  navbarShown: _this4.state.navbarShown,
                  type: item.typeShown && _this4.state.navbarShown ? item.typeShown : item.type
                }));
              }
            });
          }
          return /*#__PURE__*/_react["default"].createElement(_NavItem.NavItem, _extends({
            key: k
          }, item, {
            isTransparent: isTransparent,
            onClickAlways: _this4.toggleCollapse,
            dropdownClassName: dropdownClassName,
            dropdownCollapseClassName: dropdownCollapseClassName,
            navbarShown: _this4.state.navbarShown,
            dropdownActive: _this4.state.activeDropdown,
            onOpen: _this4.handleDropdownOpen,
            onClose: _this4.handleDropdownClose,
            forceCloseDropdown: _this4.state.forceCloseDropdown
          }, item.typeShown && {
            type: _this4.state.navbarShown || isTransparent && !_this4.state.isScrolled ? item.typeShown : item.type
          }));
        }));
      }) : null, navbarExtraContent) : null), this.state.navbarShown && !isFixed ? /*#__PURE__*/_react["default"].createElement("div", {
        "data-navbar-height": true
      }) : null, this.state.showOverlay && (dropdownOverlay || dropdownOverlayMobile) ? /*#__PURE__*/_react["default"].createElement("div", _extends({
        id: "dropdown-overlay"
      }, className("".concat(dropdownOverlay && !dropdownOverlayMobile ? 'd-none d-lg-block' : !dropdownOverlay && dropdownOverlayMobile ? 'd-lg-none' : '', " ").concat(_stylesModule["default"].overlay, " ").concat(this.state.showOverlayComplete ? _stylesModule["default"]['overlay--shown'] : '', " ").concat(dropdownOverlayClassName ? dropdownOverlayClassName : '')))) : null);
    }
  }]);
  return Navbar;
}(_react.PureComponent);
exports.Navbar = Navbar;